import React from 'react';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Autocomplete } from '@material-ui/lab';
import { Checkbox, TextField } from '@material-ui/core';
import { years as validYears } from '../../utils/constants';

const ProjectYear = ({ onChangeSelect, selectedYear: year }) => {
  const years = validYears;
  return (
    <Autocomplete
      id={'year'}
      name={'year'}
      limitTags={2}
      options={years}
      disableClearable
      getOptionLabel={(year) => year}
      onChange={(event, values) => onChangeSelect(event, values, 'year')}
      label={'Año'}
      value={year}
      renderOption={(option, { selected, inputValue }) => {
        //   console.log('inputvalue:' + selected + '; ' + inputValue);
        return (
          <React.Fragment>
            <Checkbox
              name={'type'}
              icon={<CheckBoxOutlineBlankIcon fontSize='small' />}
              checkedIcon={<CheckBoxIcon fontSize='small' />}
              style={{ marginRight: 8 }}
              checked={selected}
            />
            {option}
          </React.Fragment>
        );
      }}
      getOptionSelected={(option, value) => {
        return option === value;
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          //error={validation}
          margin='normal'
          variant='outlined'
          label={'Año'}
          size='small'
          placeholder='Seleccione un año'
          fullWidth
        />
      )}
    />
  );
};

export default ProjectYear;
